import { PAGINATION_LIMIT_VALUE_NUM, PAGINATION_NUM_VALUE_NUM } from 'constants/headers'
import { getPaginationHeaders } from 'tools/headers'
import request from 'tools/request'
import {
  AdditionalFeeGlCodesResponse,
  FactorSettingsResponse,
  FactorWhiteLabelResponse,
  FactorSettingRequest,
  WhiteLabelParams,
  AccountCollectionResponse,
  CreateFactorAccountRequest,
  CcBccEmailResponse,
  UpdateFactorCcBccRequest,
  FeatureFlagsResponse,
  UpdateFactorPaymentAccountsRequest,
  FactorConfigurationResponse,
  FactorConfigurationRequest,
  FactorTimezoneResponse,
  GetFactorChangelogQueryParams,
  FactorChangelogResponse,
  FactorFundingChargebackResponse,
  UpdateFactorChargebackSettingRequest,
} from 'types/factor'

// ========================= GETs ==========================

export const getWhiteLabel = async (params: WhiteLabelParams) => {
  const data = await request
    .get<FactorWhiteLabelResponse>(`/factors/whitelabels`, {
      params: params,
    })
    .then((res) => {
      return res.data.factor
    })
  return data
}

export const getMeFactorSettings = async () => {
  const data = await request.get<FactorSettingsResponse>(`/factors/me/settings`).then((res) => res.data)
  return data
}

export const getAdditionalFeeGlCodes = async () => {
  const data = await request
    .get<AdditionalFeeGlCodesResponse>(`/factors/me/additional-fee-gl-codes`)
    .then((res) => res.data)
  return data
}

export const getMeFactorFundingChargebackSettings = async () => {
  const data = await request
    .get<FactorFundingChargebackResponse>(`/factors/me/funding-chargeback`)
    .then((res) => res.data)
  return data
}

export const getMeFactorTimezone = async () => {
  const data = await request.get<FactorTimezoneResponse>(`/factors/me/timezone`).then((res) => res.data)
  return data
}

export const getFactorAccounts = async () => {
  const data = await request.get<AccountCollectionResponse>(`/factors/me/accounts`).then((res) => res.data.accounts)
  return data
}

export const getFeatureFlags = async () => {
  const data = await request.get<FeatureFlagsResponse>(`/feature/feature-flags`).then((res) => res.data)
  return data
}

export const getMeFactorConfiguration = async () => {
  const data = await request.get<FactorConfigurationResponse>(`/factors/me/configuration`).then((res) => res.data)
  return data
}

// ========================= POSTs ==========================

export const createFactorAccount = async (payload: CreateFactorAccountRequest) => {
  const data = await request
    .post<AccountCollectionResponse>(`/factors/me/accounts`, payload)
    .then((res) => res.data.accounts)
  return data
}

// ========================= PUTs ==========================

export const updateMeCcBccFactorEmails = async (payload: UpdateFactorCcBccRequest) => {
  const data = await request.put<CcBccEmailResponse>(`/factors/me/cc-bcc`, payload).then((r) => r.data)
  return data
}

export const updateMeFactorSettings = async (payload: FactorSettingRequest) => {
  const data = await request.put<FactorSettingsResponse>(`/factors/me/settings`, payload).then((r) => r.data)
  return data
}

export const updatePaymentAccounts = async (payload: UpdateFactorPaymentAccountsRequest) => {
  const data = await request
    .put<UpdateFactorPaymentAccountsRequest>(`/factors/me/payment-accounts`, payload)
    .then((r) => r.data)
  return data
}

export const updateFactorConfiguration = async (payload: FactorConfigurationRequest) => {
  const data = await request.put<FactorConfigurationResponse>(`/factors/me/configuration`, payload).then((r) => r.data)
  return data
}

export const updateMeFactorFundingChargebackSettings = async (payload: UpdateFactorChargebackSettingRequest) => {
  const data = await request
    .put<FactorFundingChargebackResponse>(`/factors/me/funding-chargeback`, payload)
    .then((r) => r.data)
  return data
}

export const updateFactorImageSignature = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  const data = await request
    .put<FactorConfigurationResponse>(`/factors/me/configuration/signature`, formData)
    .then((r) => r.data)
  return data
}

export const deleteImageSignature = async () => {
  const data = await request
    .delete<FactorConfigurationResponse>(`/factors/me/configuration/signature`)
    .then((r) => r.data)
  return data
}

export const getChangelogsForFactor = async (
  factorId: string,
  params: GetFactorChangelogQueryParams,
  pageNumber: number = PAGINATION_NUM_VALUE_NUM,
  pageLimit: number = PAGINATION_LIMIT_VALUE_NUM
) => {
  const data = await request
    .get<FactorChangelogResponse>(`/factors/${factorId}/changelogs`, {
      params: params,
      headers: getPaginationHeaders(pageNumber, pageLimit),
    })
    .then((res) => {
      return {
        headers: res.headers,
        data: res.data,
      }
    })
  return data
}
